import { render, staticRenderFns } from "./customerBirthdayToday.vue?vue&type=template&id=7479afbd&scoped=true&"
import script from "./customerBirthdayToday.vue?vue&type=script&lang=js&"
export * from "./customerBirthdayToday.vue?vue&type=script&lang=js&"
import style0 from "./customerBirthdayToday.vue?vue&type=style&index=0&id=7479afbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7479afbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDataTable,VRow})
